/**
 * P369 -- the MVB node set for the constellation lens
 * (MVB gap-analysis F5).
 *
 * Mirrors the backend's MVB scope (twin/mvb_scope.py): the MVB-flagged
 * IBSes plus the services supporting them, plus every transitive
 * upstream prerequisite reachable over the graph's service edges.
 * Pure so the walk is testable without a canvas.
 */
import type { TwinEdge, TwinNode } from "shared/api/types";

export function mvbNodeSet(nodes: TwinNode[], edges: TwinEdge[]): Set<string> {
  const mvbIbs = nodes.filter((n) => n.kind === "ibs" && n.mvb_flag).map((n) => n.id);
  if (mvbIbs.length === 0) return new Set();

  // Graph edges point dependent -> dependency (ibs depends_on
  // service, service depends_on parent, service hosted_by vendor), so
  // walking FROM the MVB IBSes reaches everything they rest on.
  const dependsOn = new Map<string, string[]>();
  for (const e of edges) {
    const list = dependsOn.get(e.from_id) ?? [];
    list.push(e.to_id);
    dependsOn.set(e.from_id, list);
  }

  const seen = new Set<string>(mvbIbs);
  const frontier = [...mvbIbs];
  while (frontier.length > 0) {
    const id = frontier.pop() as string;
    for (const up of dependsOn.get(id) ?? []) {
      if (!seen.has(up)) {
        seen.add(up);
        frontier.push(up);
      }
    }
  }
  return seen;
}
